/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// Redux Toolkit
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/userSlice";
// BASE Components
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../@BASE/core/NavLinkAdapter";
import authRoles from "../../../auth/authRoles";
// Material UI
import Button from "@mui/material/Button"
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

function EmptyListing(props) {
  const { resource, parent } = props;
  const user = useSelector(selectUser);

  return (
    <Paper className="flex flex-col flex-auto p-24 py-64 shadow rounded-xl overflow-hidden items-center justify-center">
      <BASESvgIcon size={32}>
        heroicons-outline:exclamation
      </BASESvgIcon>
      <Typography className="text-lg font-medium tracking-tight leading-6 truncate mt-16">
        There are no {resource} to display.
      </Typography>
      {(authRoles.leadEditor.includes(user.role)) ? (
        <>
          <Typography
            className="text-md font-medium"
            color="text.secondary"
          >
            To add new {resource}, click the add button below.
          </Typography>
          <Divider className="my-16" />
          <Button
            variant="contained"
            color="secondary"
            component={NavLinkAdapter}
            to={parent ? `/${resource}/new/edit?p=${parent}` : `/${resource}/new/edit`}
            startIcon={<BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>}
          >
            Add
          </Button>
        </>
      ) : (
        <Typography
          className="text-md font-medium"
          color="text.secondary"
        >
          Please contact your system administrator to add new {resource}.
        </Typography>
      )}
      
      

    </Paper>
  );
}

export default EmptyListing;
